<template>
    <img src="/images/promo/connect-features/abacus.png"
     alt="Abacus" />
</template>

<script>
export default {};
</script>
